import * as React from "react";
import Column from "../../ui-library/column-system/column";
import Row from "../../ui-library/column-system/row";
import Section from "../../ui-library/section/section";
import { EventCategory } from "../../../utils/analytics";
import { useCovidIntentCategoriesQuery } from "../../../hooks/static-queries/use-covid-intent-categories-query";
import CategoryCard from "../../ui-library/category-card/category-card";

const CovidCategories: React.FC = () => {
  const categories = useCovidIntentCategoriesQuery();

  if (!categories || categories.length < 1) {
    return null;
  }

  return (
    <Section heading="Topics to explore">
      <Row>
        {categories.map((c) => (
          <Column key={c.alias} spanLg={6} spanMd={6} spanSm={12}>
            <CategoryCard
              name={c.name}
              url={`/covid-19/category/${c.alias}/`}
              imageUrl={c.imageUrl}
              imagePosition={c.imagePosition}
              description={c.description}
              eventCategory={EventCategory.Section_Categories}
            />
          </Column>
        ))}
      </Row>
    </Section>
  );
};

export default CovidCategories;
